var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};


















































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel__title\" ng-if=\"!$ctrl.loading\"\u003E{{$ctrl.employee_id}} | {{$ctrl.customer.name}} | {{ personal_info.lastname }}, {{ personal_info.firstname }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003ESchritt: Nachweis Dokumente Prüfen\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.is_locked_by_me &amp;&amp; !$ctrl.loading\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDatensatz in Bearbeitung durch  {{ $ctrl.employee_lock.by_advisor.id }}, {{ $ctrl.employee_lock.by_advisor.firstname }} {{ $ctrl.employee_lock.by_advisor.lastname }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.has_finalized_contract &amp;&amp; !$ctrl.loading\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDer Arbeitnehmer hat keinen finalisierten Vertrag.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.has_pending_pc_approvals &amp;&amp; !$ctrl.loading\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EEs ist noch eine Freigabe offen. Der Vorgang kann daher noch nicht abgeschlossen werden.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.has_declined_pc_approvals &amp;&amp; !$ctrl.loading\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDie Freigabe wurde abgelehnt. Der Vorgang kann daher nicht abgeschlossen werden.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.stopControlProcessIfCheckoutContainsPC &amp;&amp; !$ctrl.loading\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDas neue PC-Leasing Typ wurde aktiviert. Der Vorgang kann daher nicht abgeschlossen werden.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5 control-dialog-box\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EStammdaten\u003C\u002Fh3\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EAdresse\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-right\"\u003E\u003Cspan\u003E{{personal_info.address.street}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003EPLZ Ort\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{personal_info.address.zip}}, {{personal_info.address.city}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003EPersonalnummer\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{ personal_info.employeenumber }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003E{{ $ctrl.customer.organization_structure.cost_center.label }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{ personal_info.kostenstelle }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003E{{ $ctrl.customer.organization_structure.organization.label }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{ personal_info.org_einheit }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003EGeburtsdatum\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{ personal_info.birthdate }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003EFirmeneintritt\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{ personal_info.entrydate }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003ETelefon\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-4\"\u003E\u003Cspan\u003EE-Mail\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-8 text-right\"\u003E\u003Cspan\u003E{{ personal_info.email }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 text-right\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.editPersonalInfo($ctrl.employee_id)\" ng-disabled=\"$ctrl.optimisation === null\"\u003EBearbeiten\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row confirm_info_areaa\"\u003E\u003Chr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"columns text-right\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "personalInfoCheckbox","key": "$ctrl.control_checkbox.personal_info","data-cy": "vn.administration.neo.controlProcessDialog.checkPersonalData","title": "Geprüft","readonly": "$ctrl.optimisation === null","attributes": {"ng-model-options":"{ allowInvalid: true }"},"required": pug.escape(true)}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
},
attributes: {"class": "row","name": "$ctrl.forms.personal_info"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 control-dialog-box right\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EÜberschrift\u003C\u002Fh3\u003E\u003Cbr\u003E\u003Cdiv ng-if=\"!$ctrl.loading\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003ESteuerbrutto\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.brutto }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003ESteuerklasse\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.pap_stkl }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EKrankenversicherung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.kv_typ }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EZusatzbeitrag\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.pap_kvz | formatNumber: '*':100:2 }} %\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EMindestlohn\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.mindestlohn }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EArbeitstage \u002F Woche\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.arbeitstage }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003ERegelarbeitszeit\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.regelarbeitszeit }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003ESteuerjahr\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.tax_info.jahr }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EOptimierungsjahr\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.extractYear($ctrl.optimisation.beginn) }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row confirm_info_areaa\"\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"column text-right\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "uberschriftCheckbox","data-cy": "vn.administration.neo.controlProcessDialog.checkTaxData","title": "Geprüft","key": "$ctrl.control_checkbox.tax","readonly": "$ctrl.optimisation === null","attributes": {"ng-model-options":"{ allowInvalid: true }"},"required": pug.escape(true)}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
},
attributes: {"class": "row","name": "$ctrl.forms.uberschrift"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5 control-dialog-box\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"info_area\" ng-if=\"$ctrl.blocking_baskets.length\"\u003E\u003Ch3\u003EOrder Prozesse\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info_area\" ng-if=\"$ctrl.blocking_baskets.length\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cdiv class=\"strong\"\u003EBaustein\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cdiv class=\"strong\"\u003EBeginn\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cdiv class=\"strong\"\u003EBrutto\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-4\"\u003E\u003Cdiv class=\"strong\"\u003EOrder Process\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"requestedBasket in $ctrl.blocking_baskets\"\u003E\u003Cdiv class=\"columns medium-3 contract-data\"\u003EPC-Leasing\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 contract-data\"\u003E{{ requestedBasket.beginDate ? ( requestedBasket.beginDate  | date ) : '-' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ requestedBasket.sum | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ $ctrl.getOrderProcessStateName(requestedBasket) }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 control-dialog-box right\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EOptimierung\u003C\u002Fh3\u003E\u003Cbr\u003E\u003Cdiv ng-if=\"!ctrl.loading\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EBeginn\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{$ctrl.optimisation.beginn}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EAIID\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.aiid }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003ECalcID\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.calcId }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EGehaltsverzicht gesamt\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.salary_waiver_total  | currency}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"component in $ctrl.optimisation.components\"\u003E\u003Cdiv class=\"column small-6\" data-cy=\"vn.administration.neo.controlProcessDialog.textComponent-{{component.name}}\"\u003E{{ component['name'] }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-3\"\u003E{{ component['value'] | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-3\"\u003E{{ $ctrl.optimisation.neo_choices[component['name']] }}\u003C\u002Fdiv\u003E\u003C!--td ${user['neo_choices'][component['name']].capitalize()}--\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EBerater\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.advisor_name }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EBerater E-Mail\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.advisor_email }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.optimisation.savings_model === 'NONE'\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EEs wurde folgende Versorgungsauswahl getroffen\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.adjustment }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.optimisation.savings_model != 'NONE'\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003EEs wurde folgendes Konzept gewählt:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cspan\u003E{{ $ctrl.optimisation.zielvorgabe }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row confirm_info_areaa\"\u003E\u003Chr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"column text-right\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "optimisationCheckbox","key": "$ctrl.control_checkbox.optimisation","data-cy": "vn.administration.neo.controlProcessDialog.checkNeoData","title": "Geprüft","readonly": "$ctrl.optimisation === null","attributes": {"ng-model-options":"{ allowInvalid: true }"},"required": pug.escape(true)}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
},
attributes: {"class": "row","name": "$ctrl.forms.optimisation"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 control-dialog-box\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EDokumentenliste\u003C\u002Fh3\u003E\u003Cbr\u003E\u003Cdocument-list-component ng-if=\"!$ctrl.loading\" options=\"{for_latest_contract_only: true, valuenet_id: $ctrl.employee_id, to_show_controls: false, show_bonus_documents: false, show_control_process_form: true}\" documents=\"ammendment_documents\"\u003E\u003C\u002Fdocument-list-component\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row confirm_info_areaa\"\u003E\u003Chr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"columns text-right\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "documentsCheckbox","key": "$ctrl.control_checkbox.documents","data-cy": "vn.administration.neo.controlProcessDialog.checkDocuments","title": "Geprüft","readonly": "$ctrl.optimisation === null","attributes": {"ng-model-options":"{ allowInvalid: true }"},"required": pug.escape(true)}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.forms.documents"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Chr\u003E\u003Cdiv class=\"column\" overlay=\"$ctrl.loading\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"columns\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "digitalSigningCheckbox","key": "$ctrl.digitalSignatureOptions.isEnabled","title": "Digitale Signatur anfordern","attributes": {"ng-model-options":"{ allowInvalid: true }"},"required": pug.escape(true)}
});
pug_html = pug_html + "\u003Cdiv ng-if=\"$ctrl.digitalSignatureOptions.isEnabled\"\u003E\u003Ch3\u003ETicket#\u003C\u002Fh3\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.digitalSignatureOptions.ticketNumber","attributes": {"ng-required":"$ctrl.digitalSignatureOptions.isEnabled"},"validationMessages": {"required":"Es wird eine Eingabe benötigt."}}
});
pug_html = pug_html + "\u003Ch3\u003EAblaufdatum Signaturvorgang\u003C\u002Fh3\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"digital_signing_expiration_date\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.digitalSignatureOptions.expirationDate","title": "Expiration","id": "digital_signing_expiration_date","attributes": {"vn-date":"true","vn-date-max":"{{$ctrl.latestExpirationDate}}","vn-date-min":"{{$ctrl.today}}","vn-date-reformat":"true","vn-date-use-utc":"true","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","ng-required":"$ctrl.digitalSignatureOptions.isEnabled"},"fieldHtmlClass": "digital_signing_expiration_date","validationMessages": {"required":"Pflichtfeld","dateMin":"Das Datum muss in der Zukunft liegen.","dateMax":"Das Datumm muss vor dem {{$ctrl.optimisation.beginn}} liegen.","parse":"Bitte Datum im Format tt.mm.jjjj eingeben"}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.digitalRequestForm.digitalSignatureForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Chr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EKommentar\u002F Korrekturhinweis\u003C\u002Fh3\u003E\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "$ctrl.comment","readonly": "$ctrl.optimisation === null","attributes": {"ng-required":"!$ctrl.requireDocsValidation() &&  ($ctrl.hasUserCheckedEverything() ? false : true)"},"validationMessages": {"required":"Es wird eine Eingabe benötigt."}}
});
},
attributes: {"name": "$ctrl.commentForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!!$ctrl.loading_error\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cdiv class=\"red\"\u003EThere was a loading error\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.is_locked_by_me &amp;&amp; !$ctrl.loading &amp;&amp; $ctrl.has_finalized_contract\"\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.canAcceptApplication()\" ng-click=\"$ctrl.accept()\" data-cy=\"vn.administration.neo.controlProcessDialog.buttonSubmit\"\u003EPrüfung Dokumente Positiv\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"(!$ctrl.commentForm.$valid || $ctrl.hasUserCheckedEverything()) || $ctrl.requireDocsValidation() || !!$ctrl.loading_error \" ng-click=\"$ctrl.ammendCalculation()\"\u003EVerwaltungsticket erstellen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.requireDocsValidation() || !!$ctrl.loading_error\" ng-click=\"$ctrl.requireNeoDocuments()\"\u003EDokumente anfordern\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;